import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { VehiculosService, AlertaService, GruposService, GeocercaService } from '../../../services/apiService';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { paginadorAlertasStore, paginadoRecorridosStore } from '../../../lib/store/paginador_store';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import alertasFiltrosStore from '../../../lib/store/alertas_filtros_store';
import { sortBy } from "underscore";
import { useFiltrosStore } from '../../../lib/store/filtros.store';
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../utils/bitacora';
import { createRenderCustomHeader } from '../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../utils/datePickerUtils';
import '../../../styles/datepicker.css'
import { jwtDecode } from 'jwt-decode';

// Activamos el soporte para formatos personalizados
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale('es');


// 📌 Registrar la localización en español para DatePicker
registerLocale('es', es);
setDefaultLocale('es'); //


const ReporteAlertasFiltros = ({ onResetForm, onGenerateReport, initialReportType, imprimir }) => {
    // ...existing code...
    const store = alertasFiltrosStore();
    const paginadorAlertas = paginadorAlertasStore();
    const paginadorRecorridos = paginadoRecorridosStore();

    const [cargandoGruposLocal, editarCargandoGruposLocal] = useState(false);
    const [gruposLocal, editarGruposLocal] = useState([]);
    const [selGruposLocal, editarSelGruposLocal] = useState([]);
    //const [selDropDownGrupos, setSelDropDownGrupos] = useState('');

    const vehiculos = useFiltrosStore((state) => state.vehiculos)
    const setVehiculos = useFiltrosStore((state) => state.setVehiculos)
    const vehiculosFiltrado = useFiltrosStore((state) => state.vehiculosFiltrado)
    const setVehiculosFiltrados = useFiltrosStore((state) => state.setVehiculosFiltrados)

    const [selectedReports, setSelectedReports] = useState('gps');
    const [selectedVehicle, setSelectedVehicle] = useState([]);
    const [selectedDropdownVehicle, setDropdownVehicle] = useState([]);
    const [selectedAlerts, setSelectedAlerts] = useState([]);
    const [selectedAlertsDropDown, setSelectedAlertsDropDown] = useState([]);
    // const [open, setOpen] = useState(true); // Unused
    const [tipoAlertas, setTipoAlertas] = useState([]);
    const [esAgrupador, setEsAgrupador] = useState(true);

    //estados para filtro omisiones
    const [selectedTiempo, setSelectedTiempo] = useState(0);
    const [selectedVeces, setSelectedVeces] = useState(0);
    const [selectedVelocidad, setSelectedVelocidad] = useState(0);
    const [selectedDistancia, setSelectedDistancia] = useState(0);
    const [selectedTipoMarcado, setSelectedTipoMarcado] = useState(null);
    const tipoMarcadoOptions = [
        { value: 0, label: 'General' },
        { value: 1, label: 'Dentro' },
        { value: 2, label: 'Fuera' }
    ];

    const [btnFiltroActivo, setBtnFiltroActivo] = useState(false);

    // Establecer valores iniciales para las fechas
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

    // Inicializar fechas con el día actual
    const [startDate, setStartDate] = useState(startOfDay);
    const [endDate, setEndDate] = useState(endOfDay);

    const reportTypes = [
        { id: 'gps', label: 'Alertas Básicas' },
        { id: 'omisiones', label: 'Omisiones' },
        { id: 'camara', label: 'Cámaras IA' }
    ];

    // Mapeo de filtros por tipo de alerta
    const filtrosPorAlerta = {
        "6091ba1d662e2b2e74500a3d": ["tiempo"], //ENTRADA DE GEOCERCA
        "6091ba29662e2b2e74500a40": ["tiempo"], //SALIDA DE GEOCERCA
        "6091ba3e662e2b2e74500a43": ["tiempo", "tipo_marcado"], //DETENIDO
        "6091ba52662e2b2e74500a46": ["tipo_marcado", "veces", "velocidad"], //Exceso de velocidad
        "6189b3ea2a2e016f281d2a05": ["tiempo", "tipo_marcado", "distancia"] //Acercamiento
    };

    const [isInitializing, setIsInitializing] = useState(false);
    const [isLoadingCombos, setIsLoadingCombos] = useState(false);

    // Handle functions for DatePicker onChange and custom header
    const handleStartDateChangeWrapper = useCallback((date) => {
        handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    const handleEndDateChangeWrapper = useCallback((date) => {
        handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Alertas', observacion: 'Alertas', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
    }, []);
    // --- VALIDACIÓN DE RANGO DE FECHAS ---
    const [dateRangeError, setDateRangeError] = useState("");
    useEffect(() => {
        if (startDate && endDate) {
            const diffInMs = endDate - startDate;
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            if (diffInDays > 30) {
                setBtnFiltroActivo(false);
                setDateRangeError("El rango de fechas no puede exceder 30 días.");
                // Swal.fire({
                //     icon: 'warning',
                //     title: 'Rango de fechas inválido',
                //     text: 'El rango de fechas no puede exceder 15 días.',
                //     confirmButtonText: 'Aceptar'
                // });
            } else {
                setDateRangeError("");
                if (selectedVehicle.length > 0 && selectedAlerts.length > 0) {
                    setBtnFiltroActivo(true);
                } else {
                    setBtnFiltroActivo(false);
                }
            }
        }
    }, [startDate, endDate, selectedVehicle, selectedAlerts]);

    // Verifica qué filtros omisiones se deben mostrar según las alertas seleccionadas
    const getFiltrosSeleccionados = () => {
        if (selectedAlerts.length === 0) return ["veces", "tiempo", "tipo_marcado"];
        const filtros = new Set();

        //console.log("total select", selectedAlerts.length);
        //console.log("total tipos", tipoAlertas.length);

        selectedAlerts.forEach(alerta => {
            const id = alerta.value;
            if (filtrosPorAlerta[id]) {
                filtrosPorAlerta[id].forEach(filtro => filtros.add(filtro));
            } else {
                ["veces", "tiempo", "tipo_marcado"].forEach(filtro => filtros.add(filtro));
            }
        });

        return Array.from(filtros);
    };

    // 👥 Cargar Grupos
    const cargarGruposLocal = async () => {
        if (cargandoGruposLocal)
            return;
        editarCargandoGruposLocal(true);
        try {
            const response = await GruposService.getGrupos();
            if (response && response.statusCode === 200) {
                const gruposData = response.data.map((grupo) => ({
                    value: grupo.uid_grupo,
                    label: `${grupo.nombre}`,
                    uid_grupo: grupo.uid_grupo
                }));
                editarGruposLocal(gruposData);
            }
        } catch (error) {
            console.error("Error cargando los grupos:", error);
        } finally {
            editarCargandoGruposLocal(false);
        }
    };
    // const loadGeocercas = async () => {
    //     try {
    //         const response = await GeocercaService.getGeocercas();
    //         if (response && response.statusCode === 200) {
    //             console.log(response);
    //             const _geocercas = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })
    //             store.editarGeocercas(_geocercas);
    //         }
    //     } catch (err) {
    //         console.error("Error cargando geocercas:", err);
    //     }
    // };

    const loadGeocercas = async () => {
        try {
            const response = await GeocercaService.getGeocercas();
            if (response && response.statusCode === 200) {
                //console.log(response);
                const _geocercas = sortBy(
                    response.data,
                    function (i) { return (i.nombre ?? "").trim().toUpperCase(); }
                ).map(g => ({
                    ...g,
                    nombre: g.nombre ?? "",
                    descripcion: g.descripcion ?? ""
                }));
                store.editarGeocercas(_geocercas);
            }
        } catch (err) {
            console.error("Error cargando geocercas:", err);
        }
    };

    const loadVehiculos = async () => {
        try {
            const response = await VehiculosService.getVehiculos();

            if (response && response.statusCode === 200) {
                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

                const vehiculosData = _vehiculos.map(vehiculo => ({
                    value: vehiculo.uid_vehiculo ?? "",
                    label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
                    uid_grupo: vehiculo.uid_grupo ?? "",
                    no_economico: vehiculo.no_economico ?? "",
                    alias: `${vehiculo.alias ?? ""}`,
                    tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
                    color_vehiculo: vehiculo.color_vehiculo ?? ""
                }));
                setVehiculos(vehiculosData);
                setVehiculosFiltrados([]);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    // Aplica lo mismo en loadVehiculosCamaraIA y loadVehiculosOmisiones:
    const loadVehiculosCamaraIA = async () => {
        try {
            const response = await VehiculosService.getVehiculosCamara();
            if (response && response.statusCode === 200) {
                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

                setVehiculos(_vehiculos.map(vehiculo => ({
                    value: vehiculo.uid_vehiculo ?? "",
                    label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
                    uid_grupo: vehiculo.uid_grupo ?? "",
                    no_economico: vehiculo.no_economico ?? "",
                    alias: `${vehiculo.alias ?? ""}`,
                    tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
                    color_vehiculo: vehiculo.color_vehiculo ?? ""
                })));
                setVehiculosFiltrados([]);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    const loadVehiculosOmisiones = async () => {
        try {
            const response = await VehiculosService.getVehiculos();
            if (response && response.statusCode === 200) {
                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

                const vehiculosData = _vehiculos
                    .map(vehiculo => ({
                        value: vehiculo.uid_vehiculo ?? "",//id_analitic 050820225
                        label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
                        uid_grupo: vehiculo.uid_grupo ?? "",
                        no_economico: vehiculo.no_economico ?? "",
                        alias: `${vehiculo.alias ?? ""}`,
                        tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
                        color_vehiculo: vehiculo.color_vehiculo ?? ""
                    }));
                setVehiculos(vehiculosData);
                setVehiculosFiltrados([]);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };


    // // 🚗 Cargar Vehículos
    // const loadVehiculos = async () => {
    //     try {
    //         const response = await VehiculosService.getVehiculos();

    //         if (response && response.statusCode === 200) {

    //             const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })

    //             const vehiculosData = _vehiculos.map(vehiculo => ({
    //                 value: vehiculo.uid_vehiculo,
    //                 label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
    //                 uid_grupo: vehiculo.uid_grupo,
    //                 no_economico: vehiculo.no_economico,
    //                 alias: `${vehiculo.alias}`,
    //                 tipo_vehiculo: vehiculo.tipo_vehiculo,
    //                 color_vehiculo: vehiculo.color_vehiculo
    //             }));
    //             setVehiculos(vehiculosData);
    //             setVehiculosFiltrados([]);
    //         }
    //     } catch (error) {
    //         console.error("Error cargando vehículos:", error);
    //     }
    // };

    // // listado Vehiculos con camaras
    // const loadVehiculosCamaraIA = async () => {
    //     try {
    //         const response = await VehiculosService.getVehiculosCamara();
    //         if (response && response.statusCode === 200) {

    //             const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })

    //             setVehiculos(_vehiculos.map(vehiculo => ({
    //                 value: vehiculo.uid_vehiculo,
    //                 label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
    //                 uid_grupo: vehiculo.uid_grupo,
    //                 no_economico: vehiculo.no_economico,
    //                 alias: `${vehiculo.alias}`,
    //                 tipo_vehiculo: vehiculo.tipo_vehiculo,
    //                 color_vehiculo: vehiculo.color_vehiculo
    //             })));
    //             setVehiculosFiltrados([]);
    //         }
    //     } catch (error) {
    //         console.error("Error cargando vehículos:", error);
    //     }
    // };
    // // 🚗 Cargar Vehículos
    // const loadVehiculosOmisiones = async () => {
    //     try {
    //         const response = await VehiculosService.getVehiculos();
    //         if (response && response.statusCode === 200) {

    //             const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })

    //             //id_analitic != null
    //             const vehiculosData = _vehiculos
    //                 .filter(vehiculo => vehiculo.id_analitic !== null)
    //                 .map(vehiculo => ({
    //                     value: vehiculo.id_analitic,
    //                     label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
    //                     uid_grupo: vehiculo.uid_grupo,
    //                     no_economico: vehiculo.no_economico,
    //                     alias: `${vehiculo.alias}`,
    //                     tipo_vehiculo: vehiculo.tipo_vehiculo,
    //                     color_vehiculo: vehiculo.color_vehiculo
    //                 }));
    //             setVehiculos(vehiculosData);
    //             setVehiculosFiltrados([]);
    //         }
    //     } catch (error) {
    //         console.error("Error cargando vehículos:", error);
    //     }
    // };

    const loadTipoAlertaQuro = async () => {
        try {
            const response = await AlertaService.getTipoAlertaQuro();
            if (response && response.statusCode === 200) {
                // 0= GPS, 1= Demo(Movil), 2= Lite
                const token = localStorage.getItem('token');
                const decoded = jwtDecode(token);
                const alertas = response.data.sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
                const grupos = [
                    { label: "Quro Lite", options: [] },
                    { label: "Quro Pro", options: [] },
                    { label: "Sensores", options: [] }
                ];

                alertas.forEach(alerta => {
                    const option = {
                        value: alerta.tipo_alerta ?? "",
                        label: alerta.nombre ?? "",
                        alerta_grupo: alerta.alertas ?? [],
                        tipo_alerta: alerta.tipo_alerta ?? ""
                    };
                    if (alerta.es_sensor === 0 && alerta.tipo_alerta > 0 && alerta.tipo_cuenta === 0) {
                        grupos[0].options.push({ ...option, disabled: false });
                    } else if (alerta.es_sensor === 0 && alerta.tipo_alerta > 0 && alerta.tipo_cuenta === 1) {
                        grupos[1].options.push({ ...option, disabled: (decoded.tipo_cuenta || 2) == 2 && alerta.tipo_cuenta == 1 });
                    } else if (alerta.es_sensor === 1) {
                        grupos[2].options.push({ ...option, disabled: false });
                    }
                });

                setTipoAlertas(grupos);
                setEsAgrupador(true);
                setSelectedAlertsDropDown([]);
            }
        } catch (error) {
            console.error("Error cargando tipo alertas GPS:", error);
        }
    };

    // Listado TipoAlerta para camara IA
    const loadTipoAlertaCamaraIA = async () => {
        try {
            const response = await AlertaService.getTipoAlertaCamaraIA();
            if (response && response.statusCode === 200) {
                const alertas = response.data.map(alerta => ({
                    value: alerta.id_camara_alerta_grupo ?? "",
                    label: `${alerta.nombre ?? ""}`,
                    alerta_grupo: alerta.alertas ?? [],
                    tipo_alerta: alerta.tipo_alerta ?? ""
                }));

                setTipoAlertas(alertas);
                setEsAgrupador(false);
                setSelectedAlertsDropDown([]);
            }
        } catch (error) {
            console.error("Error cargando tipo alertas Camaras IAs:", error);
        }
    };

    // Listado TipoAlerta para Omisiones
    const loadTipoAlertaOmisiones = async () => {
        try {
            const response = await AlertaService.getTipoAlertaOmisiones();
            if (response && response.statusCode === 200) {
                const alertas = response.data.map(alerta => ({
                    value: alerta.id ?? "",
                    label: `${alerta.nombre ?? ""}`,
                    alerta_grupo: alerta.alertas ?? [],
                    tipo_alerta: alerta.tipo_alerta ?? ""
                }));

                setTipoAlertas(alertas);
                setEsAgrupador(false);
                setSelectedAlertsDropDown([]);
            }
        } catch (error) {
            console.error("Error cargando tipo alertas Omsiones:", error);
        }
    };


    // 🚨 Cargar Alertas agrupadas en categorías
    // const loadTipoAlertaQuro = async () => {
    //     try {
    //         const response = await AlertaService.getTipoAlertaQuro();
    //         if (response && response.statusCode === 200) {
    //             const alertas = response.data.sort((a, b) => a.orden - b.orden);
    //             const grupos = [
    //                 { label: "Quro Lite", options: [] },
    //                 { label: "Quro Pro", options: [] },
    //                 { label: "Sensores", options: [] }
    //             ];

    //             alertas.forEach(alerta => {
    //                 const option = {
    //                     value: alerta.tipo_alerta,
    //                     label: alerta.nombre,
    //                     alerta_grupo: alerta.alertas,
    //                     tipo_alerta: alerta.tipo_alerta
    //                 };
    //                 if (alerta.es_sensor === 0 && alerta.tipo_alerta > 0 && alerta.tipo_cuenta === 0) {
    //                     grupos[0].options.push(option);
    //                 } else if (alerta.es_sensor === 0 && alerta.tipo_alerta > 0 && alerta.tipo_cuenta === 1) {
    //                     grupos[1].options.push(option);
    //                 } else if (alerta.es_sensor === 1) {
    //                     grupos[2].options.push(option);
    //                 }
    //             });

    //             setTipoAlertas(grupos);
    //             setEsAgrupador(true);
    //             setSelectedAlertsDropDown([]);
    //         }
    //     } catch (error) {
    //         console.error("Error cargando tipo alertas GPS:", error);
    //     }
    // };

    // // Listado TipoAlerta para camara IA
    // const loadTipoAlertaCamaraIA = async () => {
    //     try {
    //         const response = await AlertaService.getTipoAlertaCamaraIA();
    //         if (response && response.statusCode === 200) {
    //             const alertas = response.data.map(alerta => ({
    //                 value: alerta.id_camara_alerta_grupo,
    //                 label: `${alerta.nombre}`,
    //                 alerta_grupo: alerta.alertas,
    //                 tipo_alerta: alerta.tipo_alerta
    //             }));

    //             setTipoAlertas(alertas);
    //             setEsAgrupador(false); //
    //             setSelectedAlertsDropDown([]);
    //         }
    //     } catch (error) {
    //         console.error("Error cargando tipo alertas Camaras IAs:", error);
    //     }
    // };

    // // Listado TipoAlerta para Omisiones
    // const loadTipoAlertaOmisiones = async () => {
    //     try {
    //         const response = await AlertaService.getTipoAlertaOmisiones();
    //         if (response && response.statusCode === 200) {
    //             const alertas = response.data.map(alerta => ({
    //                 value: alerta.id,
    //                 label: `${alerta.nombre}`,
    //                 alerta_grupo: alerta.alertas,
    //                 tipo_alerta: alerta.tipo_alerta
    //             }));

    //             setTipoAlertas(alertas);
    //             setEsAgrupador(false);
    //             setSelectedAlertsDropDown([]);
    //         }
    //     } catch (error) {
    //         console.error("Error cargando tipo alertas Omsiones:", error);
    //     }
    // };



    // Ref para evitar doble carga cuando initialReportType llega después del mount
    const initialLoadDoneRef = useRef(false);

    useEffect(() => {
        // Si ya hicimos la carga inicial con un tipo válido, no recargar
        if (initialLoadDoneRef.current && !initialReportType) {
            return;
        }

        const tipoACargar = initialReportType || 'gps';
        const tipoValido = reportTypes.find(type => type.id === tipoACargar);

        if (!tipoValido) {
            console.warn('⚠️ [ReporteAlertasFiltros] Tipo inválido:', tipoACargar);
            return;
        }

        // Si viene initialReportType y ya cargamos GPS por defecto, limpiar antes
        if (initialReportType && initialLoadDoneRef.current) {
            setSelectedVehicle([]);
            setSelectedAlerts([]);
            setDropdownVehicle([]);
            setSelectedAlertsDropDown([]);
            setVehiculos([]);
            setVehiculosFiltrados([]);
            setTipoAlertas([]);
        }

        //console.log('📂 [ReporteAlertasFiltros] Cargando datos para tipo:', tipoACargar);
        setIsInitializing(true);
        setSelectedReports(tipoACargar);

        // Cargar vehículos y alertas según tipo
        if (tipoACargar === 'omisiones') {
            loadVehiculosOmisiones();
            loadTipoAlertaOmisiones();
        } else if (tipoACargar === 'camara') {
            loadVehiculosCamaraIA();
            loadTipoAlertaCamaraIA();
        } else {
            loadVehiculos();
            loadTipoAlertaQuro();
        }

        // Siempre cargar grupos y geocercas (solo en primera carga)
        if (!initialLoadDoneRef.current) {
            cargarGruposLocal();
            loadGeocercas();
        }

        initialLoadDoneRef.current = true;

        // Marcar como completado después de que las promises terminen
        setTimeout(() => {
            setIsInitializing(false);
        }, 500);

    }, [initialReportType]);



    // useEffect(() => {
    //     console.log('🚗 [ReporteAlertasFiltros] vehiculos cambió:', vehiculos.length, 'elementos');
    //     console.log('📋 [ReporteAlertasFiltros] vehiculos sample:', vehiculos.slice(0, 3));
    // }, [vehiculos]);

    // useEffect(() => {
    //     console.log('🚨 [ReporteAlertasFiltros] tipoAlertas cambió:', tipoAlertas.length, 'elementos');
    //     console.log('📋 [ReporteAlertasFiltros] tipoAlertas sample:', tipoAlertas.slice(0, 3));
    // }, [tipoAlertas]);

    // useEffect(() => {
    //     console.log('🚗 [ReporteAlertasFiltros] vehiculosFiltrados cambió:', vehiculosFiltrados.length, 'elementos');
    // }, [vehiculosFiltrados]);


    useEffect(() => {
        setVehiculosFiltrados(selGruposLocal || [])
    }, [selGruposLocal]);

    useEffect(() => {

        if (selectedVehicle.length > 0 && selectedAlerts.length > 0) {
            setBtnFiltroActivo(true)
        } else {

            setBtnFiltroActivo(false)
        }
    }, [selectedVehicle, selectedAlerts])

    useEffect(() => {

        //Obtiene las opciones seleccionadas
        const selectedNews = vehiculosFiltrado.filter(item => selectedDropdownVehicle.includes(item.value));

        //Inserta la nueva data seleccionada
        setSelectedVehicle(selectedNews);

    }, [selectedDropdownVehicle]);

    const handleSelectedAlerts = (value) => {

        //Obtiene las opciones del drop down
        const todasLasOpciones = tipoAlertas.flatMap(grupo => grupo.options || grupo);

        //Busca en la lista los tipos que fueron seleccionados
        const selectedoptionsDropdown = todasLasOpciones.filter(item => value.includes(item.value));

        //Inserta la nueva data seleccionada
        setSelectedAlerts([...selectedoptionsDropdown]);
        setSelectedAlertsDropDown(value);
    }


    // Al seleccionar los filtros, los pasamos al contenedor padre (index)
    const handleGenerate = () => {
        // setOpen(false); // Unused
        // 🔹 Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
        //const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
        //const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
        //const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC

        // const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
        // const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")
        const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss");
        const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss");
        let selVehiculos = selectedVehicle && selectedVehicle.length > 0 ? selectedVehicle.map(v => v.value) : [];
        let dataVehiculos = vehiculos.filter(w => selVehiculos.includes(w.value));

        generarBitacoraReporte(AccionBitacora.Generar);

        store.editarVehiculos(dataVehiculos);
        store.editarAlertas(selectedAlerts);
        store.editarFechaInicio(startDate);
        store.editarFechaFin(endDate);
        store.editarFechaInicioBefore(startDate);
        store.editarFechaFinBefore(endDate);
        store.setFirstLoad(true);
        onGenerateReport({
            fecha_inicio: _fechaInicio,
            fecha_fin: _fechaFin,
            uids_vehiculo: selVehiculos,
            ids_tipo_alerta: selectedAlerts && selectedAlerts.length > 0 ? selectedAlerts.map(a => a.value) : [],
            uids_evento: selectedAlerts && selectedAlerts.length > 0 ? selectedAlerts.map(b => b.value) : [], // solo para el caso de omisiones
            tipo_reporte: selectedReports,
            tiempo: selectedTiempo ?? 0,
            veces: selectedVeces ?? 0,
            velocidad: selectedVelocidad ?? 0,
            distancia: selectedDistancia ?? 0,
            tipo_marcado: selectedTipoMarcado ?? 0
        });
    };
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let selVehiculos = selectedVehicle && selectedVehicle.length > 0 ? selectedVehicle.map(v => v.value) : [];
            let dataGrupos = (gruposLocal || []).filter(w => (selGruposLocal || []).includes(w.value));
            let dataVehiculos = (vehiculos || []).filter(w => (selVehiculos || []).includes(w.value));
            let dataAlertas = (selectedAlerts || []);
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
        }
        guardarBitacora({
            categoria: 'Reporte Alertas',
            observacion: generarObservacion(
                reportTypes.find(type => type.id === selectedReports).label,
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                }
            ),
            tipoAccion: accion
        });
    }

    const handleReportChange = async (newReport) => {
        // Evitar ejecución durante la inicialización o si es el mismo tipo
        if (isInitializing) return;
        if (newReport === selectedReports) return;

        setSelectedReports(newReport);

        // Limpiar filtros, combos y selecciones
        setSelectedVehicle([]);
        setSelectedAlerts([]);
        setDropdownVehicle([]);
        setSelectedAlertsDropDown([]);
        setVehiculos([]);
        setVehiculosFiltrados([]);
        setTipoAlertas([]);
        setStartDate(startOfDay);
        setEndDate(endOfDay);
        setSelectedTiempo(0);
        setSelectedVeces(0);
        setSelectedVelocidad(0);
        setSelectedDistancia(0);
        setSelectedTipoMarcado(0);
        editarSelGruposLocal([]);

        onResetForm(newReport);

        // Activar loading en los combos mientras se recargan
        setIsLoadingCombos(true);

        try {
            if (newReport === 'gps') {
                await Promise.all([loadVehiculos(), loadTipoAlertaQuro()]);
            } else if (newReport === 'camara') {
                await Promise.all([loadVehiculosCamaraIA(), loadTipoAlertaCamaraIA()]);
            } else if (newReport === 'omisiones') {
                await Promise.all([loadVehiculosOmisiones(), loadTipoAlertaOmisiones()]);
            } else {
                setTipoAlertas([]);
                setVehiculos([]);
            }
        } finally {
            setIsLoadingCombos(false);
        }
    };


    // 📌 Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {
        const allSelected = selected.some(option => option.value === 'all');
        const todasLasOpciones = options.flatMap(grupo => grupo.options || grupo);
        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) {
                setSelected([]);
            } else {
                setSelected(todasLasOpciones);
            }
        } else {
            setSelected(selected);
        }
        // console.log(selectedAlerts); // Unused
    };

    // 📌 Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
            {/* <FontAwesomeIcon className="text-primary position-absolute top-50 translate-middle-y ms-2" /> */}
        </div>
    ));
    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
        [startDate, handleStartDateChangeWrapper]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
        [endDate, handleEndDateChangeWrapper]
    );

    const groupedItemTemplate = (option) => {
        return (

            <div className="flex align-items-center">
                <div>{option.label || ''}</div>
            </div>
        );
    };

    return (
        <div>
            {/* <Button onClick={() => setOpen(!open)} aria-controls="filter-collapse" aria-expanded={open} variant="link" className="mb-2">
                <FontAwesomeIcon icon={faFilter} /> {open ? 'Ocultar filtros' : 'Ver filtros'}
            </Button> */}
            {/* <Collapse in={open}> */}
            <div id="filter-collapse">
                <Row>
                    {dateRangeError && (
                        <Col xs={12}>
                            <div className="alert alert-warning py-2 my-2">
                                {dateRangeError}
                            </div>
                        </Col>
                    )}
                    <Col md={3} xs={4}>
                        <Form.Group className="mb-3">
                            <Form.Label className='label-bold'>Tipo de reporte</Form.Label>
                            {/* {reportTypes.map((report) => (
                                    <Form.Check
                                        key={report.id}
                                        type="radio"
                                        name="reportType"
                                        id={report.id}
                                        label={report.label}
                                        checked={selectedReports === report.id}
                                        onChange={() => handleReportChange(report.id)}
                                    />
                                ))} */}

                            <Dropdown
                                className="w-full md:w-14rem"
                                name='reportType'
                                options={reportTypes}
                                value={selectedReports}
                                onChange={(selected) => handleReportChange(selected.value)}
                                optionLabel="label"
                                optionValue='id'
                                placeholder="Selecciona un tipo"
                                checkmark={true}
                                highlightOnSelect={false}
                                styles={customStyles}
                                filter
                            >

                            </Dropdown>
                            {/* <Select
                                options={reportTypes}
                                classNamePrefix="react-select"
                                name="reportType"
                                value={reportTypes.find(option => option.id === selectedReports) || reportTypes[0]}
                                selected={selectedReports.id === "gps"}
                                onChange={(selected) => handleReportChange(selected.id)} //
                                getOptionLabel={(e) => e.label} // ✅ Muestra solo los labels
                                getOptionValue={(e) => e.id} // ✅ Usa `id` como valor
                            /> */}

                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label className='label-bold'>Desde</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderIniHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es"
                                timeCaption="Hora"
                                maxDate={new Date()}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label className='label-bold'>Hasta</Form.Label>
                            <DatePicker
                                selected={endDate}
                                minDate={startDate}
                                minTime={
                                    endDate.getDate() === startDate.getDate()
                                        ? startDate
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                                }
                                maxTime={
                                    endDate.getDate() === new Date().getDate() &&
                                        endDate.getMonth() === new Date().getMonth() &&
                                        endDate.getFullYear() === new Date().getFullYear()
                                        ? new Date() // hasta la hora actual si es hoy
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59) // hasta fin del día
                                }
                                onChange={handleEndDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderEndHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es" // 📌 Localización en español
                                timeCaption="Hora" // 
                                maxDate={new Date()}
                            />
                        </Form.Group>
                    </Col>


                    <Col md={3} xs={4}>
                        <Form.Label >Grupo</Form.Label>
                        <MultiSelect
                            className="multiselect-ul w-full md:w-20rem"
                            value={selGruposLocal}
                            onChange={(e) => {
                                editarSelGruposLocal(e.value)
                                setDropdownVehicle([]);
                            }}
                            options={gruposLocal}
                            optionLabel="label"
                            filter
                            placeholder="Seleccione un grupo"
                            maxSelectedLabels={2}
                            selectedItemsLabel={`${(selGruposLocal || []).length} grupos seleccionados`}
                        />
                    </Col>
                    <Col md={3} xs={4}>
                        {/* <Form.Group>
                                <Form.Label>Vehículos</Form.Label>
                                <Select closeMenuOnSelect={false} options={vehiculos} classNamePrefix="react-select" value={selectedVehicle} onChange={setSelectedVehicle} isMulti />
                            </Form.Group> */}
                        <Form.Group>
                            <Form.Label className='label-bold'>Vehículos</Form.Label>

                            <MultiSelect
                                className="multiselect-ul w-full md:w-20rem"
                                value={selectedDropdownVehicle}
                                onChange={(e) => {
                                    setDropdownVehicle(e.value)
                                }}
                                options={[...vehiculosFiltrado]}
                                optionLabel="label"
                                filter
                                placeholder={isLoadingCombos ? "Cargando vehículos..." : "Sin Selección"}
                                maxSelectedLabels={2}
                                selectedItemsLabel={`${(selectedDropdownVehicle || []).length} vehículos seleccionados`}
                                disabled={isLoadingCombos}
                                loading={isLoadingCombos}
                            />

                        </Form.Group>
                    </Col>
                    <Col md={3} xs={4}>
                        {/* <Form.Group>
                                <Form.Label>Alertas</Form.Label>
                                <Select closeMenuOnSelect={false} options={tipoAlertas} classNamePrefix="react-select" value={selectedAlerts} onChange={setSelectedAlerts} isMulti />
                            </Form.Group> */}
                        <Form.Group>
                            <Form.Label className='label-bold'>Alertas</Form.Label>
                            {/* <Select
                                placeholder="Sin selección"
                                closeMenuOnSelect={false}
                                options={[
                                    ...(selectedAlerts.length !== (esAgrupador ? tipoAlertas.flatMap(grupo => grupo.options || []) : tipoAlertas).length
                                        ? [{ value: 'all', label: 'Seleccionar todos' }]
                                        : [{ value: 'all', label: 'Deseleccionar todos' }]
                                    ),
                                    ...tipoAlertas
                                ]}
                                classNamePrefix="react-select"
                                value={selectedAlerts}
                                onChange={(selected) => handleSelectChange(selected, esAgrupador ? tipoAlertas.flatMap(grupo => grupo.options || []) : tipoAlertas, setSelectedAlerts)}
                                isMulti
                                styles={customStyles}
                            /> */}

                            {esAgrupador ? (
                                <MultiSelect
                                    key={'grouped'}
                                    value={selectedAlertsDropDown}
                                    options={tipoAlertas}
                                    onChange={(selected) => handleSelectedAlerts(selected.value)}
                                    optionLabel="label"
                                    optionGroupLabel="label"
                                    optionGroupChildren="options"
                                    optionGroupTemplate={groupedItemTemplate}
                                    placeholder={isLoadingCombos ? "Cargando alertas..." : "Sin Selección"}
                                    className="w-full md:w-20rem"
                                    maxSelectedLabels={2}
                                    filter
                                    selectedItemsLabel={`${(selectedAlertsDropDown || []).length} alertas seleccionadas`}
                                    disabled={isLoadingCombos}
                                    loading={isLoadingCombos}
                                />
                            ) : (
                                <MultiSelect
                                    key={'flat'}
                                    className="multiselect-ul w-full md:w-20rem"
                                    value={selectedAlertsDropDown}
                                    onChange={(selected) => handleSelectedAlerts(selected.value)}
                                    options={[...tipoAlertas]}
                                    optionLabel="label"
                                    filter
                                    placeholder={isLoadingCombos ? "Cargando alertas..." : "Sin Selección"}
                                    maxSelectedLabels={2}
                                    selectedItemsLabel={`${(selectedAlertsDropDown || []).length} alertas seleccionadas`}
                                    disabled={isLoadingCombos}
                                    loading={isLoadingCombos}
                                />
                            )}

                        </Form.Group>
                    </Col>
                    {selectedReports === 'omisiones' && selectedAlerts.length > 0 && selectedAlerts.length < tipoAlertas.length && (
                        <>
                            {getFiltrosSeleccionados().includes("tiempo") && (
                                <Col md={2}><Form.Group><Form.Label>Tiempo</Form.Label><Form.Control value={selectedTiempo} onChange={e => setSelectedTiempo(e.target.value)} /></Form.Group></Col>
                            )}
                            {getFiltrosSeleccionados().includes("veces") && (
                                <Col md={2}><Form.Group><Form.Label>Veces</Form.Label><Form.Control value={selectedVeces} onChange={e => setSelectedVeces(e.target.value)} /></Form.Group></Col>
                            )}
                            {getFiltrosSeleccionados().includes("velocidad") && (
                                <Col md={2}><Form.Group><Form.Label>Velocidad</Form.Label><Form.Control value={selectedVelocidad} onChange={e => setSelectedVelocidad(e.target.value)} /></Form.Group></Col>
                            )}
                            {getFiltrosSeleccionados().includes("distancia") && (
                                <Col md={2}><Form.Group><Form.Label>Distancia</Form.Label><Form.Control value={selectedDistancia} onChange={e => setSelectedDistancia(e.target.value)} /></Form.Group></Col>
                            )}
                            {getFiltrosSeleccionados().includes("tipo_marcado") && (
                                <Col md={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo Marcado</Form.Label>
                                        <Select
                                            options={tipoMarcadoOptions}
                                            classNamePrefix="react-select"
                                            value={selectedTipoMarcado.value}
                                            onChange={(selected) => setSelectedTipoMarcado(selected.value)}
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                        </>
                    )}

                    <Col md={2} xs={4}>
                        <div className="d-flex mt-4">
                            <Button variant="primary"
                                className="w-100"
                                onClick={handleGenerate}
                                disabled={!btnFiltroActivo || !!dateRangeError || (paginadorAlertas.cargando || paginadorRecorridos.cargando)}
                            >
                                Generar
                            </Button>
                        </div>
                    </Col>
                    <Col md={2} xs={4}>
                        <div className="print-report d-flex mt-4 " style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* </Collapse> */}
        </div>
    );
};

export default ReporteAlertasFiltros;